<div class="accordion" id="accordionGlossaryEntries">
  <div
    class="accordion-item my-4 shadow"
    *ngFor="let entry of entries; let first = first"
  >
    <h2 class="accordion-header" id="headingEntry{{ entry.identifier }}">
      <button
        class="accordion-button border-0 text-primary text-decoration-none"
        type="button"
        data-bs-toggle="collapse"
        [attr.data-bs-target]="'#collapse' + entry.identifier "
        aria-expanded="true"
        aria-controls="'collapse' + entry.voce"
      >
        {{ entry.voce }}
      </button>
    </h2>
    <div
      id="collapse{{ entry.identifier  }}"
      class="accordion-collapse collapse"
      [ngClass]="{'show': first, 'collapsed': !first}"
      [attr.aria-labelledby]="'headingEntry' + entry.identifier"
      data-bs-parent="#accordionGlossaryEntries"
    >
      <div class="accordion-body">
        {{ entry.descr }}
      </div>
    </div>
  </div>
</div>
